import React from 'react';
import Markdown from 'markdown-to-jsx';
import {
  validateYouTubeUrl,
  checkImageUrl,
  generateRandomNumber,
} from '../../utils/helperFunctions';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ReactPlayer from 'react-player';
import { copyToClipboard } from '../../utils/helperFunctions.js';
import PostImageItem from './PostImageItem';
import { useTheme } from '../../theme';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import {
  Wrapper,
  Code,
  ButtonCopyClipboard,
} from './styles/ContentMarkDown.styles';

const ContentMarkDown = ({ post, className }) => {
  const { theme } = useTheme();
  const handleClickCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const targetToCopy = e.target.nextSibling;
    const randomNumber = generateRandomNumber();
    //set Id to pre tag
    const id = `code-${randomNumber}`;
    targetToCopy.id = id;
    copyToClipboard(id);
    e.target.innerText = 'Copied';
  };
  const HeadingsMainOfPost = ({ children, ...props }) => {
    return <h2 {...props}>{children}</h2>;
  };
  const HeadingsSubsetOfPost = ({ children, ...props }) => {
    return <h3 {...props}>{children}</h3>;
  };

  const CodeOfPost = ({ children, ...props }) => {
    let language;
    switch (props.className) {
      case 'lang-json':
        language = 'json';
        break;
      case 'lang-markdown':
        language = 'markdown';
        break;
      case 'lang-python':
        language = 'python';
        break;
      case 'lang-javascript':
        language = 'javascript';
        break;
      case 'lang-plaintext':
        language = 'plaintext';
        break;
      default:
        language = 'code';
    }
    if (language === 'code')
      return <code className={'simple-code'}>{children}</code>;
    return (
      <Code>
        <ButtonCopyClipboard onClick={handleClickCopy}>
          Copy
        </ButtonCopyClipboard>
        <SyntaxHighlighter language={language} style={tomorrow}>
          {children}
        </SyntaxHighlighter>
      </Code>
    );
  };

  const AnchorOfPost = ({ children, ...props }) => {
    const { href: uri } = props;
    if (validateYouTubeUrl(uri)) {
      return <ReactPlayer url={uri} controls width="100%" height="450px" />;
    }
    if (checkImageUrl(uri)) {
      return <PostImageItem src={uri} title={uri} />;
    }
    return (
      <a
        {...props}
        target="_blank"
        rel="noreferrer"
        className="post-link"
        style={{ wordBreak: 'break-word' }}
      >
        {children}
      </a>
    );
  };
  const ImageOfPost = ({ children, ...props }) => {
    return <PostImageItem src={props.src} totle={props.title} />;
  };
  const ParagraphOfPost = ({ children, props }) => {
    return <p {...props}>{children}</p>;
  };
  const UnOrderListOfPost = ({ children, props }) => {
    return <ul {...props}>{children}</ul>;
  };
  const OrderListOfPost = ({ children, props }) => {
    return <ol {...props}>{children}</ol>;
  };
  const TableComponentOfPost = ({ children, props }) => {
    return (
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          {children}
        </Table>
      </TableContainer>
    );
  };
  const TableHeadComponentOfPost = ({ children }) => {
    return <TableHead>{children}</TableHead>;
  };
  const TableRowComponentOfPost = ({ children, props }) => {
    if (!children.length) return null;
    return (
      <TableRow>
        {children.map((cell) => (
          <TableCell key={cell.key}>{cell}</TableCell>
        ))}
      </TableRow>
    );
  };
  const options = {
    overrides: {
      h2: {
        component: HeadingsMainOfPost,
      },
      h3: {
        component: HeadingsSubsetOfPost,
      },
      code: {
        component: CodeOfPost,
      },
      a: {
        component: AnchorOfPost,
      },
      img: {
        component: ImageOfPost,
        props: {
          className: 'post-image',
        },
      },
      p: {
        component: ParagraphOfPost,
      },
      ul: {
        component: UnOrderListOfPost,
      },
      ol: {
        component: OrderListOfPost,
      },
      table: {
        component: TableComponentOfPost,
      },
      thead: {
        component: TableHeadComponentOfPost,
      },
      tr: {
        component: TableRowComponentOfPost,
      },
    },
  };
  return (
    <Wrapper theme={theme}>
      <Markdown options={options}>{post}</Markdown>
    </Wrapper>
  );
};

export default React.memo(ContentMarkDown);
